import React from 'react';
import { Typography, Box } from '@mui/material';
import { useParams } from 'react-router-dom';

const AthleteOrganizer = () => {
  const { id } = useParams();

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Organize Athletes
      </Typography>
      <Typography variant="body1">
        Organize athletes for competition #{id}
      </Typography>
    </Box>
  );
};

export default AthleteOrganizer;
